import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store/store";

import {AppHistoryType, AppType, isWentBackAndToggledFalseEnum} from "../types/app.type";
import { APP_NAVIGATE_DIRECTION } from "../constants/app.constant";

const initialState: AppType = {
	title: "LiveFX",
	navigateDirection: APP_NAVIGATE_DIRECTION.NEXT,
	history: [],
	isRootScrollable: true,
	debugMode: false,
	backFromPath: {path: ""},
	isWentBackAndToggledFalse: isWentBackAndToggledFalseEnum.FIRST_OPEN_PAGE,
	triggerCloseApp:"",

};

export const appSlice = createSlice({
	name: "app",
	initialState,
	// The `reducers` field lets us define reducers and generate associated actions
	reducers: {
		updateAppTitle: (state, action: PayloadAction<string>) => {
			state.title = action.payload;
		},
		setNavigateDirection: (
			state,
			action: PayloadAction<APP_NAVIGATE_DIRECTION>
		) => {
			state.navigateDirection = action.payload;
		},
		pushHistory: (state, action: PayloadAction<AppHistoryType>) => {
			state.history.push(action.payload);
		},
		popHistory: (state, action: PayloadAction<number>) => {
			if (action.payload < 0 && isFinite(action.payload))
				state.history = state.history.slice(0, Math.trunc(action.payload));
		},
		replaceHistory: (state, action: PayloadAction<AppHistoryType>) => {
			if (state.history.length > 0)
				state.history[state.history.length - 1] = action.payload;
		},
		setIsRootScrollable: (state, action: PayloadAction<boolean>) => {
			state.isRootScrollable = action.payload;
		},
		setDebugMode: (state, action: PayloadAction<boolean>) => {
			state.debugMode = action.payload;
		},
		setBackFromPath: (state, action: PayloadAction<AppHistoryType>): void => {
			state.backFromPath = action.payload
		},
		setIsWentBackAndToggledFalse: (state, action: PayloadAction<isWentBackAndToggledFalseEnum>): void => {
			state.isWentBackAndToggledFalse = action.payload
		},
		updateTriggerCloseApp:(state): void => {
			state.triggerCloseApp = "triggered" + Math.random()
		},
	},
});

export const {
	updateAppTitle,
	setNavigateDirection,
	pushHistory,
	popHistory,
	replaceHistory,
	setIsRootScrollable,
	setDebugMode,
	setBackFromPath,
	setIsWentBackAndToggledFalse,
	updateTriggerCloseApp
} = appSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`

export const selectApp = (state: RootState) => state.app;
export const selectAppHistory =(state:RootState) =>state.app.history
export const selectAppHistoryPrevPagePath = (state:RootState) =>{
	if(state.app.history.length-2 <0){
		return ""
	}
	return state.app.history[state.app.history.length-2].path
}

export const selectAppBackFromPath = (state:RootState) =>state.app.backFromPath.path;

export const selectAppTriggerCloseApp = (state:RootState) =>state.app.triggerCloseApp


// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
// export const incrementIfOdd =
//   (amount: number): AppThunk =>
//   (dispatch, getState) => {
//     const currentValue = selectCount(getState());
//     if (currentValue % 2 === 1) {
//       dispatch(incrementByAmount(amount));
//     }
//   };

export default appSlice.reducer;
